// src/app/PanelSwitch.tsx
import { useNavigate } from "@tanstack/react-router";
import { Building2, ShieldCheck } from "lucide-react";

import type { PanelMode } from "./panel-mode";
import { setPanelMode } from "./panel-mode";

/** يظهر فقط للحساب "الهجين" (أدمن منصة وله مشاريعه الخاصة كمان) — تبديل واضح بين اللوحتين،
 * كل واحدة بتاخد المستخدم لمسار افتراضي مناسب ليها فور التبديل. */
export function PanelSwitch({ mode }: { mode: PanelMode }) {
  const navigate = useNavigate();

  function go(next: PanelMode) {
    if (next === mode) return;
    setPanelMode(next);
    void navigate({ to: next === "platform" ? "/platform" : "/dashboard" });
  }

  const tab = (active: boolean) =>
    `flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12.5px] transition-colors ${active ? "bg-gold text-bg font-semibold" : "text-muted-2"}`;

  return (
    <div role="tablist" aria-label="التبديل بين لوحة المشاريع ولوحة إدارة المنصة" className="flex items-center gap-1 rounded-full border border-line-2 bg-[rgba(6,17,28,.5)] p-1">
      <button type="button" role="tab" aria-selected={mode === "projects"} data-testid="panel-switch-projects"
        onClick={() => go("projects")} className={tab(mode === "projects")}>
        <Building2 size={13} aria-hidden /> لوحة المشاريع
      </button>
      <button type="button" role="tab" aria-selected={mode === "platform"} data-testid="panel-switch-platform"
        onClick={() => go("platform")} className={tab(mode === "platform")}>
        <ShieldCheck size={13} aria-hidden /> إدارة المنصة
      </button>
    </div>
  );
}
